import React from 'react'
import {Col, CustomInput, Form, FormGroup, Label, Row} from "reactstrap";
import FieldWithValidation from "../../generic/fields/FieldWithValidation";
import {Controller} from "react-hook-form";
import {getProductOptionsMultiselect, getTaxationType} from "../../administration/certificates/certificate/tabs/General/Parameters";
import {SelectControllerRHF, TextControllerRHF} from "../../generic/fields";
import {Constants} from "sv-common";
import {requiredRule} from "../../../lib/utils/helper";
import Select from "react-select";
import i18n, {t} from "i18next";
import ElementWithAccessInCountries from "../../../lib/utils/hocs/ElementWithAccessInCountries";
import InstallmentInputs from "./InstallmentInputs";
import InfoTooltip from "../../generic/InfoTooltip";

const PAYMENT_SYSTEMS = Constants.PAYMENT_SYSTEMS;

const EditModalChildren = ({entity, setEntity, control, errors, handleInput, register}) => {
    const {language} = i18n

    const setCertificateTypes = certificateTypes =>
        setEntity({
            ...entity,
            'certificate_types': (certificateTypes || []).map(certificateType => certificateType.value)
        })

    const setTaxation = taxationType => {
        setEntity({
            ...entity,
            taxation: taxationType ? taxationType.value : ''
        });
    }

    const productTypeOptionsMultiselect = getProductOptionsMultiselect(language)
    const typeTaxationOptions = getTaxationType(language)

    return <Form>
        <Row>
            <Col lg={4}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="name"
                        defaultValue={entity.name || ''}
                        rules={{required: t('inputs.validation.required')}}
                        render={(
                            {value, onBlur, name, ref, onChange},
                            {invalid}
                        ) =>
                            <FieldWithValidation invalid={invalid} errors={errors} name={name} isRequired={true}
                                                 label={t('directories.legalEntities.name')}
                                                 type="text" onBlur={onBlur} value={value}
                                                 placeholder={t('directories.legalEntities.namePlaceholder')}
                                                 onChange={e => onChange(handleInput(e, setEntity).value)}
                            />
                        }
                    />
                </FormGroup>
            </Col>
            <Col lg={4}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="shop_id"
                        defaultValue={entity.shop_id || ''}
                        rules={{required: t('inputs.validation.required')}}
                        render={(
                            {value, onBlur, name, ref, onChange},
                            {invalid}
                        ) =>
                            <FieldWithValidation invalid={invalid} errors={errors}
                                                 label={t('directories.legalEntities.shopIdLabel')}
                                                 name={name} isRequired={true}
                                                 hint={entity.type === PAYMENT_SYSTEMS.TINKOFF
                                                     ? t('directories.legalEntities.shopIdHint') : ''}
                                                 type="text" onBlur={onBlur} value={value}
                                                 placeholder="XXXXXXXXX-XXXXXXXXX-XXXXXXXXX-XXXXXXXXX"
                                                 onChange={e => onChange(handleInput(e, setEntity).value)}
                            />
                        }
                    />
                </FormGroup>
            </Col>
            <Col lg={4}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="api_key"
                        defaultValue={entity.api_key || ''}
                        rules={{required: t('inputs.validation.required')}}
                        render={(
                            {value, onBlur, name, ref, onChange},
                            {invalid}
                        ) =>
                            <FieldWithValidation invalid={invalid} errors={errors} name={name} isRequired={true}
                                                 label={t('directories.legalEntities.apiKeyLabel')}
                                                 type="text" onBlur={onBlur} value={value}
                                                 placeholder="XXXXXXXXXXXXXXXXXX-XXXXXXXXX-XXXXXXXXX-XXXXXXXXX"
                                                 onChange={e => onChange(handleInput(e, setEntity).value)}
                            />
                        }
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col xs={6} lg={4}>
                <FormGroup>
                    <Label>{t('directories.legalEntities.certificateType')}</Label>
                    <Select
                        name="certificate_type" isMulti options={productTypeOptionsMultiselect}
                        onChange={setCertificateTypes} menuPlacement={'top'}
                        value={(entity.certificate_types || []).map(val => productTypeOptionsMultiselect
                            .filter(option => option.value === val)[0])}
                    />
                </FormGroup>
            </Col>
            <Col xs={6} lg={4}>
                <FormGroup>
                    <SelectControllerRHF inputName={'type'} control={control} setValue={e => handleInput(e, setEntity)}
                                         isRequired label={t('directories.legalEntities.paymentSystem')}
                                         rules={requiredRule} defaultValue={entity.type || ''}
                                         errors={errors} options={[
                        <option value={''} disabled>{t('directories.legalEntities.chooseType')}</option>,
                        ...Object.keys(PAYMENT_SYSTEMS)
                            .map(k => <option key={k} value={PAYMENT_SYSTEMS[k]}>{PAYMENT_SYSTEMS[k]}</option>)
                    ]}
                    />
                </FormGroup>
            </Col>
            <ElementWithAccessInCountries hideInCountries={['EN']}>
                <Col xs={6} lg={4}>
                    <FormGroup>
                        <Controller
                            control={control}
                            name="insurance_id"
                            defaultValue={entity.insurance_id || ''}
                            render={(
                                {value, onBlur, name, ref, onChange},
                                {invalid}
                            ) =>
                                <FieldWithValidation invalid={invalid} errors={errors} name={name} isRequired={true}
                                                     label={t('directories.legalEntities.insuranceId')}
                                                     type="text" onBlur={onBlur} value={value}
                                                     placeholder={t('directories.legalEntities.insuranceIdPlaceholder')}
                                                     onChange={e => onChange(handleInput(e, setEntity).value)}
                                />
                            }
                        />
                    </FormGroup>
                </Col>
            </ElementWithAccessInCountries>
        </Row>
      <ElementWithAccessInCountries hideInCountries={['EN']}>
        <Row>
          <Col lg={6}>
            <FormGroup>
              <CustomInput type="checkbox" className={'custom-switch'} id="subscription_available"
                           name="subscription_available" label={t('directories.legalEntities.subscriptionAvailable')}
                           checked={entity.subscription_available || false} onChange={e => handleInput(e, setEntity)}/>
            </FormGroup>
          </Col>
            <Col lg={6}>
                <FormGroup>
                    <div className="d-flex">
                        <CustomInput type="checkbox" className={'custom-switch'} id="two_step_payment"
                                     name="two_step_payment" label={t('directories.legalEntities.twoStepPayment')}
                                     checked={entity.two_step_payment || false} onChange={e => handleInput(e, setEntity)}/>
                        <InfoTooltip text={t('globalSettings.separateFunctionality.enableTwoStepPaymentInfo')}  container={'.modal'}/>
                    </div>
                </FormGroup>
            </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={12}>
            <FormGroup>
                <Label>{t('directories.legalEntities.taxation')}</Label>
                <Select
                    name="taxation" isMulti={false} options={typeTaxationOptions}
                    onChange={setTaxation} menuPlacement={'bottom'}
                    value={typeTaxationOptions.find(opt => opt.value === entity.taxation)}
                />
            </FormGroup>
          </Col>
          {PAYMENT_SYSTEMS.TINKOFF === entity.type && (
              <Col lg={12}>
                  <Row>
                      <Col lg={6}>
                          <FormGroup>
                              <Controller
                                  control={control}
                                  name="tax"
                                  defaultValue={entity.tax || ''}
                                  render={(
                                      {value, onBlur, name, ref, onChange},
                                      {invalid}
                                  ) =>
                                      <FieldWithValidation
                                          invalid={invalid}
                                          errors={errors}
                                          label={t('directories.legalEntities.tax')}
                                          name={name}
                                          type="text"
                                          onBlur={onBlur}
                                          value={value}
                                          placeholder="vat5"
                                          onChange={e => onChange(handleInput(e, setEntity).value)}
                                      />
                                  }
                              />
                          </FormGroup>
                      </Col>
                      <Col lg={12}>
                          <InstallmentInputs register={register} control={control} errors={errors} entity={entity} />
                      </Col>
                  </Row>
              </Col>
          )}
        </Row>
      </ElementWithAccessInCountries>
    </Form>
}

export default EditModalChildren;
